(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("rb_dsgnsys.corvid[WutAvatar]", [], factory);
	else if(typeof exports === 'object')
		exports["rb_dsgnsys.corvid[WutAvatar]"] = factory();
	else
		root["rb_dsgnsys.corvid[WutAvatar]"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 